import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatatableClickEvent } from '@basis/angular-components';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SelectItem } from 'primeng/primeng';
import { BaseStepComponent } from "app/base";
import { environment } from 'environments/environment';
import { PadraoService } from '../../../service/padrao.service';

@Component({
    selector: 'permissoes-pendentes-etapa2',
    templateUrl: './permissoes-pendentes-etapa2.component.html',
})
export class CrudPermissoesPendentesEtapa2Component extends BaseStepComponent {
    @Input() SistemaOptions: SelectItem[];
    @Input() PerfilOptions: SelectItem[];
    @Input() LotacaoOptions: SelectItem[];
    @Input() StatusOptions: SelectItem[];

    @Input() uploadedFiles: any[];
    @Input() storagedListFiles: any[];
    @Output() uploadedFilesChange = new EventEmitter<any>();
    uploadedFilesTemp: any[] = [];

    init() {
        if (this.uploadedFiles.length > 0) {
            this.uploadedFilesTemp = [];
            this.uploadedFiles.forEach(i => {
                i.show = true;
                this.uploadedFilesTemp.push(i);
            });
            this.uploadedFiles = [];
            this.uploadedFiles = this.uploadedFilesTemp;
        }
        this.uploadedFilesChange.emit(this.uploadedFiles);

    }
}


// WEBPACK FOOTER //
// ./src/app/permissoes-pendentes/crud/etapas/permissoes-pendentes-etapa2.component.ts